package com.essntl.features.message.ui.all_conversation

import com.essntl.features.message.domain.model.WhapiMessageModel
import com.essntl.uikit.components.chat.conversation.ConversationFilterOptions

sealed interface AllConversationEvent {
    data class SelectConversation(val conversationId: String) : AllConversationEvent
    data class UpdateChatLastMessage(val chatId: String, val lastMessage: WhapiMessageModel) : AllConversationEvent
    data class ChangeFilterOptions(val filterOptions: ConversationFilterOptions) : AllConversationEvent
    data object GetAllWhapiChats : AllConversationEvent
    data object GetNextConversationsPage : AllConversationEvent
}